import { RunSchema } from '@/types/schema';

export function getRepetitionNumber(
  allReps: RunSchema[],
  runId: string
): number {
  return allReps.findIndex((rep) => rep.id === runId) + 1;
}
